/**
 * COS-22-R — LA MARCA "EN ESTE APARATO YA SE INICIÓ SESIÓN ALGUNA VEZ".
 *
 * LA REGLA DE CARLOS, literal: "está bien que de inicio te lleve a sign up, pero
 * si ya has iniciado sesión alguna vez e hiciste logout desde tu cuenta pues ahí
 * sí que te lleve a pantalla de sign in".
 *
 * O sea: la regla SIGNUP-first de F4.3b sigue siendo la correcta para el
 * ARRANQUE EN FRÍO de una app recién instalada (la primera pantalla es "crea tu
 * cuenta"), y deja de serlo en cuanto ESTE aparato ya vio una sesión — quien ya
 * tiene cuenta quiere "Log in".
 *
 * PROPIEDADES (las tres son load-bearing, hay tests que las fijan):
 *
 *   · POR APARATO, NO POR CUENTA. Es una preferencia de la instalación, no un
 *     dato de usuario: no viaja al servidor y no se compara contra ningún id.
 *
 *   · MONOTÓNICA. Se enciende y NUNCA se apaga: ni con logout, ni con borrado de
 *     cuenta, ni al cambiar de cuenta. No existe una función para apagarla — esa
 *     ausencia ES el mecanismo. (Desinstalar la app sí se la lleva, y eso es lo
 *     correcto: vuelve a ser una instalación nueva.)
 *
 *   · SOBREVIVE MATAR LA APP. localStorage es la persistencia que el repo ya usa
 *     para preferencias de app dentro del WebView (`lang_preference` en
 *     lib/language.js, `flashcard_onboarding_seen` en Flashcards.js), con el
 *     mismo try/catch de siempre: en modo privado o con storage bloqueado se
 *     degrada a "no hay marca", que es el comportamiento de hoy — jamás a error.
 *
 * QUIÉN LA ENCIENDE: AuthContext, en un solo sitio (el efecto que ve cualquier
 * `user` no-invitado vigente), así ningún camino de entrada se queda fuera —
 * login, verificación de registro, OAuth, conversión de invitado y también la
 * restauración de sesión al arrancar (que es lo que cubre a los usuarios que ya
 * tenían la app instalada antes de este cambio).
 *
 * QUIÉN LA LEE: routeGuards, y sólo en el build de app.
 */
const SIGNED_IN_BEFORE_KEY = 'sb_signed_in_before';

export function markSignedInBefore() {
  try { localStorage.setItem(SIGNED_IN_BEFORE_KEY, '1'); } catch { /* private mode */ }
}

export function hasSignedInBefore() {
  try { return localStorage.getItem(SIGNED_IN_BEFORE_KEY) === '1'; } catch { return false; }
}

// Exportado para tests: fija el nombre único y constante de la llave.
export const _SIGNED_IN_BEFORE_KEY = SIGNED_IN_BEFORE_KEY;

/* post-t7-1 (J1, #564): LA MARCA HERMANA, "EN ESTE APARATO YA HUBO UN INVITADO". Se enciende en el mismo sitio del
   contexto de sesion cuando se ve un usuario invitado (solo en la app), vive en el mismo almacenamiento y nunca se
   apaga. Con cualquiera de las dos encendida, la bienvenida de la app no vuelve a salir. */
const GUEST_BEFORE_KEY = 'sb_guest_before';

export function markGuestBefore() {
  try { localStorage.setItem(GUEST_BEFORE_KEY, '1'); } catch { /* private mode */ }
}

export function hadGuestBefore() {
  try { return localStorage.getItem(GUEST_BEFORE_KEY) === '1'; } catch { return false; }
}

export const _GUEST_BEFORE_KEY = GUEST_BEFORE_KEY;
